export default __webpack_public_path__ + "static/media/football.8b0c6121.jpeg";